import { select, take } from 'redux-saga/effects';
import { SagaIterator } from 'acscp/sagas/core/sagaEffects';
import { AppState } from 'acscp/store';

export function* waitFor(selector: (state: AppState) => boolean): SagaIterator {
    if (yield select(selector)) {
        return;
    }

    while (true) {
        // Listen to all possible updates to the state
        yield take();
        if (yield select(selector)) {
            return;
        }
    }
}
